import React from "react";
import classNames from "classnames";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DashboardIcon from "@material-ui/icons/Dashboard";
import { withStyles } from "@material-ui/core/styles";
import {
  AddOutlined,
  Business, ListAlt,
  People,
  Receipt,
  Shop
} from '@material-ui/icons'
import {useSelector} from "react-redux";
import {getCurrentCompany, getCurrentRole, getDrawerOpened} from '../../containers/mainReducer'
import { useHistory } from 'react-router'

const drawerWidth = 240;

const styles = theme => ({
  drawerPaper: {
    position: "fixed",
    top: theme.spacing(8),
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(7)
    }
  }
});

const Sidebar = props => {
  const { classes } = props;
  const currentRole = useSelector(getCurrentRole);
  const currentCompany = useSelector(getCurrentCompany);
  const history = useHistory();
  const open = useSelector(getDrawerOpened);

  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: classNames(
          classes.drawerPaper,
          !open && classes.drawerPaperClose
        )
      }}
      open={open}
    >
      <List>
          <ListItem button onClick={() => history.push("/")}>
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Naslovna" />
          </ListItem>
        {currentCompany && ["OWNER"].includes(currentRole) &&
          <ListItem button onClick={() => history.push("/reports")}>
            <ListItemIcon>
              <Business />
            </ListItemIcon>
            <ListItemText primary="Promet po vrsti plaćanja" />
          </ListItem>
        }
      </List>
    </Drawer>
  );
};

export default withStyles(styles)(Sidebar);
